// extracted by mini-css-extract-plugin
module.exports = {"btnOpportunityContainer":"ButtonsStrip_btnOpportunityContainer__3v_kc","btnOpenCvContainer":"ButtonsStrip_btnOpenCvContainer__2KrpU","btnGrid":"ButtonsStrip_btnGrid__p0oI2"};